import backgroundImage from '../../images/background.webp';
function BackgroundWidget(props) {
  return <div style={{backgroundImage: `url(${backgroundImage})`}} className="auth-wrapper-container">{props.children}</div>
}

export default BackgroundWidget;